











import { defineComponent, computed, ref, watch } from '@vue/composition-api';
export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: [],
    },
  },
  setup(props, context) {
    const innerValue = computed({
      get() {
        return props.value;
      },
      set(val) {
        context.emit('update:value', val);
      },
    });
    const showList = ref(false);

    const methods = {
      selectItem(item: string) {
        innerValue.value = item;
        showList.value = false;
      },
      onFocus() {
        showList.value = true;
      },
      clickoutside() {
        showList.value = false;
      },
    };

    return {
      innerValue,
      showList,
      ...methods,
    };
  },
});
